// @ts-nocheck
import {store} from "../index";
import * as AES from "crypto-js/aes";
import * as UTF8 from "crypto-js/enc-utf8";
import {DOMAIN_TYPE, REPORTING_URL} from "../constants";
import axios from "axios";
import {updateAuthFlag} from "../ducks";

const ENC_KEY = "amex-session-enc@123";

export function closeScreen() {
    try {
        if (window.opener) {
            window.opener.location.reload();
            window.opener.closePopup();
        } else {
            // (window as any).top.removeIframe();
            window.top.location.reload();
        }
    } catch (e) {
        console.log(e);
    }
}

export function validateSession(validate?: boolean) {
    if (DOMAIN_TYPE !== "americanexpress") {
        return true;
    }
    let state: any = store.getState();
    const {authenticationCode, authenticated} = state;
    if (authenticated) return true;
    const sessionCode = window.sessionStorage.getItem("session_key");
    let decryptedData: any = decryptSession(sessionCode);
    if (decryptedData && validate) {
        validateCode(decryptedData);
    }
    return (sessionCode && authenticationCode && decryptedData === authenticationCode);
}

export function encryptSession(sessionId) {
    const ciphertext = AES.encrypt(sessionId, ENC_KEY).toString();
    window.sessionStorage.setItem("session_key", ciphertext);
}

export function decryptSession(sessionId) {
    let decryptedData: any = null;
    if (sessionId) {
        const bytes = AES.decrypt(sessionId, ENC_KEY);
        decryptedData = bytes.toString(UTF8);
    }
    return decryptedData;
}

export function validateCode(myCode) {
    axios({
        method: "GET",
        url: `${REPORTING_URL}/accessControl/${myCode}`,
        timeout: 6000,
    }).then((response: any) => {
        const {data} = response;
        if (data && data.status) {
            const {code} = data.status;
            if (code === "0000") {
                store.dispatch(updateAuthFlag(true));
            } else {
                throw "Error";
            }
        } else {
            throw "Error";
        }
    }).catch(err => {
        window.sessionStorage.clear();
        window.location.href = "/session";
    });
}

export function validateEmail(value) {
    if (!value || checkStringForOnlySpaces(value)) {
        return false;
    }
    let re = /^(([^<>()\[\]\\.,;:\s@?*"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(value).toLowerCase());
}

export function checkStringForOnlySpaces(str: String) {
    return str ? !str.replace(/\s/g, "").length : true;
}